export enum AuthActionType {
    SHOW_LOADER = 'SHOW_LOADER',
}